/** @format */
import { api } from 'utility';
import { getGuildServiceUrl } from 'URLs';
class ComparativeAccountServices {
  async getList() {
    return api.get(getGuildServiceUrl());
  }
}

const comparativeAccountServices = new ComparativeAccountServices();
export default comparativeAccountServices;
